import React from 'react';
import '../../App.css';
function Contact() {
    return (
        <div className='container'>
            <div className='row mt-5 flex-column' style={{marginBottom: "7rem"}}>
                <h1 className='subheader36 green-text'>Contact Us</h1>
                <br />
                <p className='mb-5'> For renters: Reach out to us at <a href="mailto:support@bubble.africa">support@bubble.africa</a>
                </p><p>For enquiries and all other reasons feel free to drop us an email <a href="mailto:team@bubble.africa">team@bubble.africa</a></p>
            </div>
            
        </div>
    )
}

export default Contact;

